import { SHIPPING_METHOD_TYPE } from '@/modules/perseo-billing/constants/src/index';
import type {
  TOrderConfirmationDelivery,
  TPickupDelivery
} from '@/modules/perseo-billing/interfaces/src/bff-web/billing/index';
import type {
  IDeliveryGroup,
  IOrder
} from '@/modules/perseo-billing/interfaces/src/bff-web/billing/interfaces/orderV2';

const constructHomeDelivery = (delivery: IDeliveryGroup, order: IOrder) => {
  const deliveryMethod = delivery?.shippingOption?.shippingType;
  const optionSelected = delivery?.optionSelected;
  const shippingAddress = order?.shippingAddress;

  const isPickUp = deliveryMethod === 'COLLECT';

  const shippingMethodType = isPickUp
    ? SHIPPING_METHOD_TYPE.PICK_UP
    : SHIPPING_METHOD_TYPE.HOME_DELIVERY;

  return {
    shippingMethodType: shippingMethodType ?? '',
    deliveryDateFrom: optionSelected?.deliveryDateFrom ?? '',
    deliveryDateTo: optionSelected?.deliveryDateTo ?? '',
    shipDate: optionSelected?.shipDate ?? '',
    timeSlot: optionSelected?.timeSlots ?? [],
    streetName: shippingAddress?.streetName ?? '',
    streetNumber: shippingAddress?.streetNumber ?? '',
    apartment: shippingAddress?.apartment ?? '',
    commune: shippingAddress?.commune ?? shippingAddress?.department ?? '',
    region: shippingAddress?.region ?? '',
    shippingServiceName: delivery?.shippingOption?.shippingMethod ?? ''
  } as unknown as TOrderConfirmationDelivery;
};

const constructPickupDelivery = (
  delivery: IDeliveryGroup,
  order: IOrder
): TPickupDelivery => {
  const shippingAddress = order?.shippingAddress;
  const { optionSelected, shippingOption, collectOnBehalfName } =
    delivery || {};

  const {
    collectNodeAddress: collectInfo,
    shippingCapability,
    deliveryDateFrom,
    shipDate,
    collectNodeName,
    collectNodeCode
  } = optionSelected || {};

  const recipientFullName =
    (delivery?.collectOnBehalfName || shippingAddress?.firstName) ?? '';

  const isPickupCopec = shippingCapability === 'PICKUP_COPEC';
  const optionDate = isPickupCopec ? deliveryDateFrom : shipDate;

  const response = {
    shippingMethodType: SHIPPING_METHOD_TYPE.PICK_UP,
    pickupStoreCommune: collectInfo?.collectComunaName ?? '',
    pickupStoreStreetName: collectInfo?.collectNodeAddress1 ?? '',
    pickupStoreStreetNumber: collectInfo?.collectNodeAddress2 ?? '',
    deliveryDateString: optionDate ?? '',
    pickupStoreName: collectNodeName ?? '',
    storeId: collectNodeCode ?? '',
    shippingServiceName: shippingOption?.shippingMethod ?? '',
    recipientFullName,
    proxyPickup: !!collectOnBehalfName
  };
  return response;
};

export { constructHomeDelivery, constructPickupDelivery };
